import axiosInstance from "./axiosInstance";

/**
 * Calls the customer login API.
 * @param {object} credentials - The user's credentials.
 * @param {string} credentials.username - The username.
 * @param {string} credentials.password - The password.
 * @returns {Promise} The promise from the axios POST request.
 */
export const loginApi = (credentials) => {
  const payload = {
    ...credentials,
    site: process.env.REACT_APP_SITE_ID,
  };
  return axiosInstance.post("/auth/login", payload);
};
